import { Col, Row } from 'antd';
import { DocumentUriConstant } from 'src/constants';
import { useAccountSelector } from 'src/hooks';
import { ClientServicesLink, MFormSection, MTypography } from 'src/lib';
import { Color, Spacing } from 'src/styles';

export const AccountBeneficiariesSection = () => {
  const { account } = useAccountSelector();

  if (!account?.type.isRetirement) {
    return null;
  }

  return (
    <>
      <MTypography
        variant='h4'
        weight='normal'
        color={Color.Brand6}
        className={Spacing.my32}
        testId='account-ira-beneficiaries-title'>
        IRA Beneficiaries (Optional)
      </MTypography>
      <MFormSection isEditable={false} isEditMode={false} testId={'account-ira-beneficiaries'}>
        <Row>
          <Col span={24}>
            <MTypography variant='h6' testId='account-ira-beneficiaries-description'>
              Please fill out and sign the{' '}
              <a href={DocumentUriConstant.IRA_BENEFICIARY_DESIGNATION_FORM} target='_blank' rel='noreferrer'>
                IRA Beneficiary Designation Form{' '}
              </a>
              if you would like to add account beneficiaries to your account in the future. Once your My IPO account is
              active please email it to <ClientServicesLink />.
            </MTypography>
          </Col>
        </Row>
      </MFormSection>
    </>
  );
};
